import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

const AddCeoLayout = () => {
    return (
        <div className="flex flex-col min-h-screen bg-gray-50">
            <Sidebar />
            <main className="flex-1 overflow-x-hidden overflow-y-auto">
                <Outlet />
            </main>
        </div>
    );
};

export default AddCeoLayout;
